// src/components/booksData.js

import image2 from "../images/image2.jpg";
import image3 from "../images/image3.jpeg";
// Placeholder images (replace with actual images)
import placeholder1 from "../images/placeholder1.jpg";
import culture from "../images/culture.jpg";
import placeholder2 from "../images/placeholder2.jpg";
import placeholder3 from "../images/placeholder3.jpg";
import adghatarbre from "../images/adghatarbre.JPEG";
import Adghatmer from "../images/Adghatmer.jpg";
import IMG_7204 from "../images/IMG_7204.jpeg";

import couverture from "../images/Couverture.png";

import imgQualia from "../images/placeholder3.jpg";
import imgFragmented from "../images/IMG_7204.jpeg";

const booksData = [
  {
    id: 3,
    title: {
      fr: "Habiter le presque",
      en: "Habiter le presque",
      ar: "Habiter le presque"
    },
    subtitle: {
      fr: "Recueil de poèmes illustré",
      en: "Illustrated poetry collection",
      ar: "ديوان شعري مصور"
    },
    isNew: true,
    isMontage: true,
    isZoomed: true,
    author: "Hajar Ouhsine",
    image: couverture,
    description_ar: `« في الثغراتِ تنبتُ الأزهار، بين شقوق الأسفلت أو بين أحجار الرصف.
وبين أحجار رصفِ الحياة ومحنها، وبين التجربة الحميمة والاجتماعية، تتموضع قصائد هذا الديوان.
على مسافةٍ واعية من المسلّمات والأفكار الجاهزة، وبمنأى عن الشجن المفتعل واللامبالاة.
تأتي بتعاطفٍ لا محاباة فيه، تبدو غامضةً أحياناً، ولا تهاب المفارقة، لتدعونا إلى متعةِ تذوّقٍ عذب، وإلى علاقةٍ مع العالم تنطوي على شيءٍ من الحكمة، وسط جمال "ذلك الشيء الذي لا يُوصَف"* و"اللاشيء تقريباً"* الذي يصنع ملح الحياة. »`,
    description_fr: `« C’est dans les interstices que poussent les fleurs entre les fentes du bitume ou entre les pavés.

C’est entre les pavés de la vie et de ses épreuves, de l’expérience intime et sociale que se situent les poèmes de ce recueil.

À bonne distance des évidences et des idées reçues, du pathos et de l’indifférence.

Avec empathie, mais sans complaisance, parfois énigmatiques, ne craignant pas le paradoxe, ils se proposent à un goûter suave, à un rapport au monde qui inclurait quelque sagesse, au milieu de la beauté du “Je-ne-sais-quoi” et du “presque-rien” qui fait le sel de la vie. »`,
    description_en: `"Habiter le presque" is an illustrated poetry collection that explores the beauty of the "je-ne-sais-quoi" and the "presque-rien" that makes life worth living.`,
    alt: "Cover of Habiter le presque by Hajar Ouhsine",
    release_date: {
      fr: "19 mai 2026",
      en: "May 19, 2026",
      ar: "19 ماي"
    },
    quote_fr: `« C’est dans les interstices que poussent les fleurs entre les fentes du bitume ou entre les pavés... »`,
    quote_author: "Dominique Zins",
    goodreads_link: "https://www.goodreads.com/book/show/251838243-habiter-le-presque?from_search=true&from_srp=true&qid=Lf710faoAM&rank=1",
    order_info: `يمكنكم طلب الديوان عبر المنصات التالية :

    - [Le Lys Bleu Éditions](https://www.lysbleueditions.com/litterature/poesie/habiter-le-presque/)
    - [Fnac](https://www.fnac.com/a23051816/Hajar-Ouhsine-Habiter-le-presque)
    - [Amazon](https://www.amazon.com/Habiter-presque-Hajar-Ouhsine/dp/B0GZGDW12Y/ref=sr_1_1?crid=2QDV5JKLWMDTR&dib=eyJ2IjoiMSJ9.6-1utWwMdbiXxOY6AxPw5g.zHx-bLT_j9r0aPw1cY5MQZcEZYQG_-J7h0LgafsYZtA&dib_tag=se&keywords=habiter+le+presque&qid=1778327815&s=books&sprefix=habiter+le+presqu%2Cstripbooks-intl-ship%2C277&sr=1-1)
    `,
    additional_images: [], 
  },
  {
    id: 1,
    title: {
      fr: "Qualia",
      en: "Qualia",
      ar: "كواليا"
    },
    author: "هاجر أوحسين",
    image: imgQualia,
    description_ar: `كواليا ليس الكتاب الأول لهاجر أوحسين بالعربية فهي عاشقة للكتابة الأدبية رغم أنها مهاجرة إليها من تخصص بعيد عن الأدب ومن تكوين أكاديمي بلغة غير عربية.
في التجنيس اختارت هاجر "نصوص" وهي واعية، ولكنها تقارب لحظات عابرة أو ممتدة بتأمل يمتزج فيه الفلسفي بالأدبي وتريد في ذلك هذا الانتساب.
ومن خلال العنوان فإنه ينير إلى طريق الوعي مشكلةً وإرادةً وتأملاً، ولذلك فهناك المحتجزون بإرادتهم في عدم اقتحام المعارف والحياة المغايرة، وهناك السابحون في بحور الوجود والمعرفة والحياة بذات تتوخى الموضوعية وهذا اختيار هاجر.
23 نصاً في كتاب كواليا مهداة إلى الراحلة مؤسسة رابطة كاتبات المغرب وفاء لها واستحضاراً لنضالها الثقافي. نصوص تبتدئ ب "صمت" يتلوه "تيه" فما يسبق الآخر؟ وآخر نص "عمل" وقبله "سلام" هو ناتج عن الإعداد الموجِّـه في مواجهة الرغبة في تقرير المصير الذاتي للانتماء إلى الحياة والانخراط في التأسيس إلى السلام.
أليست هذه هي مشاغل الجيل الجديد وأحلامه؟ لا وصاية ولا جحود.
ما يجمع نصوص كواليا هي أنها تتطاول بهدوء ورزانة على الحياة المعاندة لجموح الفرد بأحلامه وسدود وأسوار الواقع أمامه... هي إلحاح على القفز على الحواجز بعقل لا بجنون، بل ب "كواليا".
ذ. أحمد لمسيح
كاتب وزجال مغربي`,
    description_fr: `Qualia n'est pas le premier livre de Hajar Ouahcine en arabe. Elle est passionnée d'écriture littéraire, bien qu'elle y ait « migré » depuis une spécialité éloignée de la littérature et d'une formation académique dans une langue autre que l'arabe.
En matière de genre littéraire, Hajar a consciemment opté pour l'appellation de « Textes ». Néanmoins, elle aborde des instants, qu'ils soient fugaces ou prolongés, avec une méditation où le philosophique se mêle au littéraire, revendiquant sciemment cette filiation.
À travers son titre, l'œuvre éclaire le chemin de la conscience en tant que problématique, volonté et méditation. C'est pourquoi l'on trouve, d'une part, ceux qui s'enferment de leur propre gré, refusant d'explorer les savoirs et les vies alternatives, et d'autre part, ceux qui nagent dans les océans de l'existence, de la connaissance et de la vie avec une subjectivité aspirant à l'objectivité. Tel est le choix de Hajar.
Les 23 textes du livre Qualia sont dédiés à la regrettée fondatrice de la Ligue des Écrivaines du Maroc, en signe de fidélité et en hommage à son militantisme culturel. Des textes qui s'ouvrent sur le « Silence », suivi de l'« Égarement » mais lequel précède l'autre ? Le dernier texte s'intitule « Action », précédé par la « Paix » ; une paix fruit d'une préparation directrice face au désir d'autodétermination, pour s'ancrer dans la vie et s'engager dans l'édification de la paix.
Ne sont-ce pas là les préoccupations et les rêves de la nouvelle génération ? Sans tutelle ni ingratitude.
Ce qui relie les textes de Qualia, c'est cette façon de défier, avec calme et pondération, une vie qui s'obstine à contrarier les rêves fougueux de l'individu et les barrages érigés par la réalité... C'est une insistance à franchir les obstacles, non pas avec folie, mais avec raison, et plus précisément avec Qualia.
M. Ahmed Lemsih
Écrivain et poète de Zajal marocain`,
    description_en: `Qualia is not Hajar Ouahcine’s first book in Arabic. She is devoted to literary writing, even though she "migrated" to it from a field far removed from literature and from an academic background in a non Arabic language.
Regarding genre, Hajar consciously chose the label "Texts." However, she approaches moments whether fleeting or prolonged with a contemplation that blends the philosophical with the literary, deliberately seeking this affiliation.
Through its title, the book illuminates the path of consciousness as a challenge, a will, and a reflection. Thus, there are those who willingly confine themselves, refusing to venture into new knowledge and alternative ways of living; and there are those who swim in the oceans of existence, knowledge, and life with a self that strives for objectivity. This latter path is Hajar's choice.
The 23 texts in the book Qualia are dedicated to the late founder of the League of Moroccan Women Writers, out of loyalty and in commemoration of her cultural activism. These texts begin with "Silence," followed by "Wandering" so which precedes the other? The final text is "Action," preceded by "Peace," which is the outcome of a guiding preparation in the face of the desire for self determination: to belong to life and actively engage in establishing peace.
Are these not the preoccupations and dreams of the new generation? Without paternalism or denial.
What unites the texts of Qualia is their calm and composed defiance of a life that stubbornly resists the individual's unbridled dreams and the dams and walls of reality that stand in their way... It is a persistence to leap over hurdles with reason rather than madness indeed, with Qualia.
Prof. Ahmed Lemsih
Moroccan writer and Zajal poet`,
    goodreads_link: "https://www.goodreads.com/book/show/68757190",
    release_date: "2022",
    isMontage: true,
    order_info: `Les Editions Orion

    - مكتبة الألفية، الرباط (Librairie Al Alfia) - [اطلب من هنا](https://librairiealfia.com/index.php?route=product/product&manufacturer_id=90592&product_id=480329)
    
    Pour les commandes: 0773 070396
    `,
    additional_images: [culture, image2, placeholder1], 
  },
  {
    id: 2,
    title: {
      fr: "Fragments de rêves",
      en: "Fragmented Dreams",
      ar: "أضغاث أحلام"
    },
    author: "هاجر أوحسين",
    image: imgFragmented,
    description_ar: `"أضغاث أحلام" هو العمل الأدبي الأول للكاتبة المغربية هاجر أوحسين، مهندسة طبوغرافية وخريجة معهد الحسن الثاني للزراعة والبيطرة. صدر الكتاب في مارس 2021 عن دار مقاربات للنشر والصناعات الثقافية بفاس. يتألف من 64 صفحة ويضم 50 قصة قصيرة جدًا، تندرج ضمن سلسلة "إبداع" وتصنيف "قصص". لوحة غلاف الكتاب من إبداع الفنانة نوال الحلبي.`,
    description_fr: `Fragments de Rêves (Adghath Ahlam) est la première œuvre littéraire de l'auteure marocaine Hajar Ouhsine, ingénieure topographe et diplômée de l'Institut Agronomique et Vétérinaire Hassan II. Publié en mars 2021 par la maison d'édition Mouqarabat pour la culture et les arts à Fès, le livre compte 64 pages et comprend 50 micro-histoires classées sous "Créativité" et "Histoires". L'illustration de couverture est de l'artiste Nawal Al-Halabi.`,
    description_en: `Dream Fragments (Adghath Ahlam) is the debut literary work by Moroccan author Hajar Ouhsine, a topographical engineer and graduate of the Hassan II Institute of Agronomy and Veterinary Medicine. Published in March 2021 by Mouqarabat Publishing House for Culture and Arts in Fez, the book comprises 64 pages and includes 50 micro-stories categorized under "Creativity" and "Stories." The cover artwork is by the artist Nawal Al-Halabi.`,
    alt: "Cover of Fragmented Dreams by Hajar Ouhsine",
    isMontage: true,
    release_date: "2021",
    order_info: `أضغاث أحلام متوفر في المكتبات التالية.

    - مكتبة الألفية، الرباط (Librairie Al Alfia) - [اطلب من هنا](https://librairiealfia.com/index.php?route=product/product&product_id=452225&search=%D8%A3%D8%B6%D8%BA%D8%A7%D8%AB+%D8%A3%D8%AD%D9%84%D8%A7%D9%85+&category_id=0)
    - مكتبة الفجر، فاس.
    - مكتبة مكة، الرياض، مكناس.
    - مكتبة المعرض، شارع القدس، الرياض مكناس.
    - مكتبة وراقة،  مكناس . Librairie des Ecoles
    - Revues et journaux, Meliani Naoufal, Hamria en face de cinéma Caméra.
    - المكتبة المحمدية، الدار البيضاء.
    - مكتبة نور الهدى، أكادير.
    - مكتبة نجود، القصر الكبير.
    `,
    
    quote_ar: `"تأمل يمزج بين الفلسفي والأدبي، لمقاربة لحظات عابرة أو ممتدة."`,
    quote_fr: `"Une contemplation qui mêle le philosophique et le littéraire pour aborder des moments éphémères."`,
    quote_en: `"A contemplation that blends the philosophical and the literary to approach ephemeral moments."`,
    quote_author: "أحمد لمسيح - Ahmed Lemsiyeh",
    additional_images: [Adghatmer, adghatarbre, IMG_7204], 
  },
  // Add more book objects as needed
];

export default booksData;
